import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { repositoryAPI } from '../../services/api';
import { repoKeys } from '../../query/queryKeys';
import toast from '../../services/toast';

/**
 * Tech stack query and scan mutation for repository overview.
 */
export function useRepositoryTechStack(id, repositoryId) {
  const queryClient = useQueryClient();

  const techStackQuery = useQuery({
    queryKey: repoKeys.techStack(id),
    queryFn: async () => {
      const data = await repositoryAPI.getTechStack(id);
      return data.techStack || null;
    },
    enabled: !!id && !!repositoryId,
  });

  const scanMutation = useMutation({
    mutationFn: () => repositoryAPI.scanTechStack(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: repoKeys.techStack(id) });
    },
    onError: (err: unknown) => {
      toast.error((err as Error).message || 'Failed to scan tech stack');
    },
  });

  return {
    techStack: techStackQuery.data ?? null,
    techStackLoading: techStackQuery.isPending,
    techStackScanning: scanMutation.isPending,
    refetchTechStack: techStackQuery.refetch,
    handleScanTechStack: () => scanMutation.mutate(),
  };
}
